import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell } from "recharts";
import { Card } from "../../../ui/card";
import { CompanyStats } from "../../../../types/interview";

interface InterviewsChartProps {
  data: CompanyStats[];
  type: "bar" | "pie";
}

// Expanded color palette for more companies
// Rich color palette for pie chart slices
const PIE_COLORS = [
  "#0071bd", "#28a745", "#ff9800", "#e91e63", "#9c27b0", "#00bcd4", "#4caf50", "#ffc107", "#ff5722", "#8bc34a",
  "#3f51b5", "#f44336", "#cddc39", "#2196f3", "#795548", "#607d8b", "#bdbdbd", "#009688", "#673ab7", "#ffeb3b"
];

export const InterviewsChart = ({ data, type }: InterviewsChartProps) => {
  // Assign a color to each company for pie chart
  const pieData = data.map((item, idx) => ({
    name: item.companyName,
    value: item.total,
    color: PIE_COLORS[idx % PIE_COLORS.length],
  }));

  return (
  <Card className="p-6 shadow-lg border-0 bg-white animate-slide-up">
      <h3 className="text-xl font-semibold mb-6 text-card-foreground">
        {type === "bar" ? "Company-wise Interview Analysis" : "Interview Distribution"}
      </h3>
      <div className="h-[400px]">
        <ResponsiveContainer width="100%" height="100%">
          {type === "bar" ? (
            <BarChart data={data}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e9ecef" />
              <XAxis dataKey="companyName" stroke="#6c757d" />
              <YAxis stroke="#6c757d" />
              <Tooltip 
                contentStyle={{ 
                  backgroundColor: "hsl(var(--card))", 
                  border: "1px solid hsl(var(--border))",
                  borderRadius: "0.5rem",
                }}
              />
              <Legend />
              {/* Completed: green, Pending: orange */}
              <Bar dataKey="completed" name="Completed" fill="#28a745">
                {data.map((entry, idx) => (
                  <Cell key={`bar-completed-${idx}`} fill="#28a745" />
                ))}
              </Bar>
              <Bar dataKey="pending" name="Pending" fill="#ff9800">
                {data.map((entry, idx) => (
                  <Cell key={`bar-pending-${idx}`} fill="#ff9800" />
                ))}
              </Bar>
            </BarChart>
          ) : (
            <PieChart>
              <Pie
                data={pieData}
                cx="50%"
                cy="50%"
                labelLine={false}
                label={({ name, percent }) => `${name} (${(percent * 100).toFixed(0)}%)`}
                outerRadius={120}
                dataKey="value"
              >
                {pieData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip 
                contentStyle={{ 
                  backgroundColor: "hsl(var(--card))", 
                  border: "1px solid hsl(var(--border))",
                  borderRadius: "0.5rem",
                }}
              />
            </PieChart>
          )}
        </ResponsiveContainer>
      </div>
    </Card>
  );
};
